import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ChartsService } from '../../../../services/chartService/charts.service';
import { BarChartSpecification } from '../../../../dataModels/data-models';

declare var AmCharts;

@Component({
    moduleId: module.id,
    selector: 'basic-bar-chart',
    templateUrl: 'basicBarChart.component.html',
    styleUrls: ['basicBarChart.component.css']
})

export class BasicBarChart implements OnInit {
    @Input() chartSpecification: BarChartSpecification;

    constructor(private chartsService: ChartsService) { }
    drawIt: boolean = false;

    ngOnInit() {
        this.chartsService.notifyMe.subscribe(() => this.drawChart());

        this.drawChart();
    }

    drawChart() {
        let chartData: any[];

        chartData = this.chartsService.groupByThenSumOrAvg(this.chartSpecification.data,
            this.chartSpecification.yAxis, this.chartSpecification.value, this.chartSpecification.perProperty);

        chartData = this.chartsService.sortDesc(chartData, this.chartSpecification.value);
        if (this.chartSpecification.barCount)
            chartData = chartData.slice(0, this.chartSpecification.barCount);

        this.drawIt = chartData.length > 0 ? true : false;
        setTimeout(() => {
            AmCharts.makeChart(this.chartSpecification.divId, {
                "theme": "none",
                "type": "serial",
                "dataProvider": chartData,
                "valueAxes": [{
                    "title": this.chartSpecification.valueAxisTitle
                }],
                "titles": [{
                    "text": this.chartSpecification.title,
                    "size": 15
                }],
                "graphs": [{
                    "balloonText": this.chartSpecification.balloonText,
                    "fillAlphas": 1,
                    "lineAlpha": 0.2,
                    "title": this.chartSpecification.graphTitle,
                    "type": "column",
                    "valueField": this.chartSpecification.value
                }],
                "depth3D": 20,
                "angle": 30,
                "rotate": true,
                "categoryField": this.chartSpecification.yAxis,
                "categoryAxis": {
                    "gridPosition": "start",
                    "fillAlpha": 0.05,
                    "position": "left"
                },
                "export": {
                    "enabled": true
                }
            });
        }, 20);
    }
}




// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/barCharts/basicBarChart/BasicBarChart.component.ts